// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "your-project.firebaseapp.com",
//   projectId: "your-project",
//   storageBucket: "your-project.appspot.com",
//   messagingSenderId: "123456789",
//   appId: "1:123456789:web:abcdef123456"
// };
const firebaseConfig = {
  apiKey: "AIzaSyB6w0Yc2ZhuoqcYugziK4OLZjtENuvDNLQ",
  authDomain: "react-hello-32ab2.firebaseapp.com",
  projectId: "react-hello-32ab2",
  storageBucket: "react-hello-32ab2.firebasestorage.app",
  messagingSenderId: "958475585739",
  appId: "1:958475585739:web:75fbd505d8164d2e30f34e"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// ✅ Firestore
export const db = getFirestore(app);